<div class="print-content">
  <figure *ngIf="isGeneral" class="general d-flex justify-content-center">
      <qrcode [qrdata]="generalQR" [width]="generalWidth" [errorCorrectionLevel]="'M'" [elementType]="'url'"></qrcode>
  </figure>
  <mat-grid-list [cols]="cols" [rowHeight]="height" class="qr-cont"
    *ngIf="!isGeneral && (data && data.generalWidth ? data.generalWidth <= 8 : true)">
    <mat-grid-tile *ngFor="let qr of multiQR; let i = index">
      <figure>
          <qrcode [qrdata]="qr.qr" [width]="width" [errorCorrectionLevel]="'M'" [elementType]="'url'"></qrcode>
          <h4> Mesa N° {{ qr.number }}</h4>
      </figure>
    </mat-grid-tile>
  </mat-grid-list>
  <div *ngIf="!isGeneral && (data && data.generalWidth ? data.generalWidth > 8 : true)">
    <figure *ngFor="let qr of multiQR; let i = index" class="text-center">
      <qrcode [qrdata]="qr.qr" [width]="width" [errorCorrectionLevel]="'M'" [elementType]="'url'"></qrcode>
      <h4> Mesa N° {{ qr.number }}</h4>
    </figure>
  </div>
</div>
